import interceptorSetup from './utils/interceptor';

export const routeNames = {
  newGate: 'new-gate',
  newUser: 'new-user',
  newClaim: 'new-claim',
  newStatus: 'new-status',
  newAirline: 'new-airline',
  newUserRole: 'new-user-role',
  newCheckinRow: 'new-checkin-row',
  createPermission: 'create-permission',
  editUserRole: 'edit-user-role',
  editUser: 'edit-user',
  editGate: 'edit-gate',
  editClaim: 'edit-claim',
  editStatus: 'edit-status',
  editAirline: 'edit-airline',
  editCheckinRow: 'edit-checkin-row',
  manageRole: 'manage-role',
  manageUser: 'manage-user',
  manageGate: 'manage-gate',
  manageClaim: 'manage-claim',
  manageStatus: 'manage-status',
  manageCheckinRow: 'manage-checkin-row',
  manageAirline: 'manage-airline',
  managePermission: 'manage-permission',
  flightManager: 'flight-manager',
  login: 'login-user',
  register: 'register-user',
  userProfile: 'user-profile',
  report: 'report',
  operator: 'operator',

  
};

interceptorSetup();
